/** Public CloudFront hosts that serve artifacts `/agents/*` covers. */
export const AGENT_MEDIA_HOSTS = [
  "https://pulse.igentify.in",
  "https://admin.pulse.igentify.in",
] as const;

export function resolveAgentAvatarUrl(agent: {
  avatarUrl?: string | null;
  avatarKey?: string | null;
}): string | null {
  const url = String(agent.avatarUrl || "").trim();
  if (url) return url;
  const key = String(agent.avatarKey || "").trim().replace(/^\//, "");
  if (!key.startsWith("agents/")) return null;
  return `${AGENT_MEDIA_HOSTS[0]}/${key}`;
}

/** Alternate CDN URL if the primary cover fails to load in the browser. */
export function alternateAgentAvatarUrl(currentSrc: string, avatarKey?: string | null): string | null {
  const key = String(avatarKey || "").trim().replace(/^\//, "");
  if (!key.startsWith("agents/")) return null;
  for (const host of AGENT_MEDIA_HOSTS) {
    const candidate = `${host}/${key}`;
    if (candidate !== currentSrc) return candidate;
  }
  return null;
}
